angular.module('common.directives.omSpinner', [])

    // OrderManager loading spinner directive
    .directive('omSpinner', function () {
        return {
            restrict: 'AEC',
            templateUrl: 'common/directives/omSpinner/omSpinner.html',
            scope: {
                size: '@'
            },
            controller: 'OmSpinnerController'
        };
    })

    .controller('OmSpinnerController', function ($scope, $element, $window, $interval) {
        
    })
;